<!-- eslint-disable -->
<template>
  <div :class="['col-md-8 col-lg-8 offset-md-2 offset-lg-2 page eh-ds', { 'page--mobile': isMobile() }]">
    <div class="page-help-corner">
      <help-icon help-id="cpt" title="Help for CPT" />
    </div>
    <div class="cpt__list">
      <h1 :class="['list__header mt-md-0 mt-0', { 'list__header--mobile': isMobile() }]">CPT ASSIGNMENTS</h1>

      <p v-if="deviceLoadError" class="device-load-error" role="alert" data-test="cpt-device-load-error">{{ deviceLoadError }}</p>
      <p v-if="readingsLoadError" class="device-load-error" role="alert" data-test="cpt-readings-load-error">{{ readingsLoadError }}</p>

      <template v-if="!isMobile()">
        <div class="gridarea">
          <div class="container">
            <div class="columntop">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
                <span id="col1" class="coltext">Code</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                <span id="col2" class="coltext">Description</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
                <span id="col3" class="coltext">Frequency</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                <span id="col4" class="coltext">Meter(s)</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col5" class="coltext">Current Cycle Start</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col6" class="coltext">Current Cycle End</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col7" class="coltext">Current Cycle Count</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
                <span id="col8" class="coltext">Status</span>
              </div>
            </div>
            <template v-for="(cpt, key, index) in cptInfo">
              <div
                class="columnrow"
                data-bs-toggle="collapse"
                :href="'#cptInfo' + key"
                aria-expanded="false"
                :aria-controls="'cptInfo' + key"
                role="button"
              >
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                  <span id="cptCode" class="coltext">{{ key }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row-device">
                  <span id="cptDesc" class="coltext">{{ cpt.desc }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                  <span id="cptFreq" class="coltext">{{ cpt.timeframe }}</span>
                </div>
                <div
                  class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row-device meterListColumn"
                >
                  <div v-if="currentMeters.length != 0" class="meterList">
                    <span
                      v-for="meter in assignedMeters[key]"
                      :id="'meterList' + meter['0'] + meter['1']"
                      :key="'test' + meter['0'] + meter['1']"
                      class="coltext"
                    >
                      {{ meter.meter + (meter.meterName ? ` (${meter.meterName})` : "") }}
                    </span>
                  </div>
                  <span id="meterOptions" class="coltext">
                    <select
                      @change.stop="addingNewMeter(key)"
                      v-model="addedMeter[key]"
                      :id="'addedMeter' + key + index"
                    >
                      <option selected :value="0">Add Meter</option>
                      <option
                        v-for="meter in availableMeters(key)"
                        :key="meter.MeterID._text + 'cpt' + key"
                        :value="meter"
                      >
                        {{ meter.MeterID._text + " (" + meter.MeterName._cdata + ")" }}
                      </option>
                    </select>
                  </span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                  <span id="cycleStart" class="coltext">{{
                    currentData[key] ? currentData[key].firstDate : "N/A"
                  }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                  <span id="cycleEnd" class="coltext">{{
                    currentData[key] ? currentData[key].lastDate : "N/A"
                  }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                  <span id="cycleCount" class="coltext">{{
                    currentData[key]
                      ? formatCycleCount(key, currentData[key].cycleCount)
                      : "N/A"
                  }}</span>
                </div>
                <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                  <span id="cycleStatus" class="coltext">{{
                    cycleStatusLabel(key)
                  }}</span>
                </div>
              </div>
              <div class="collapse cpt-expand" :id="'cptInfo' + key">
                <div class="cpt-expand__body">
                  <cpt-desc
                    :cpt="key"
                    :currentInfo="currentData[key]"
                    :historicalInfo="getHistoricalData(key)"
                    :measurements="getCptMeas(key)"
                    @cycle-shown="cycleShown(key, $event)"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="table-container">
          <div class="accordion">
            <div
              v-for="(cpt, key, index) in cptInfo"
              :key="key"
              :id="'cpt' + key"
              class="accordion-item"
            >
              <button type="button" class="accordion-button" @click="showCpt(key)">
                {{ key }} — {{ cpt.desc }}
              </button>
              <div class="accordion-content" @click.stop>
                <p><b>Frequency:</b> {{ cpt.timeframe }}</p>
                <div class="cpt-mobile-meters">
                  <p><b>Meter(s):</b></p>
                  <ul v-if="assignedMeters[key].length" class="cpt-mobile-meter-list">
                    <li
                      v-for="meter in assignedMeters[key]"
                      :key="'mobile-meter-' + key + meter.meter"
                    >
                      {{ meter.meter + (meter.meterName ? ` (${meter.meterName})` : "") }}
                    </li>
                  </ul>
                  <p v-else class="cpt-mobile-empty">No meters assigned</p>
                  <select
                    v-if="currentMeters.length"
                    class="cpt-mobile-select"
                    @change="addingNewMeter(key)"
                    v-model="addedMeter[key]"
                    :id="'addedMeterMobile' + key + index"
                  >
                    <option selected :value="0">Add Meter</option>
                    <option
                      v-for="meter in availableMeters(key)"
                      :key="meter.MeterID._text + 'cpt-mobile' + key"
                      :value="meter"
                    >
                      {{ meter.MeterID._text + " (" + meter.MeterName._cdata + ")" }}
                    </option>
                  </select>
                </div>
                <p><b>Cycle Start:</b> {{ currentData[key] ? currentData[key].firstDate : "N/A" }}</p>
                <p><b>Cycle End:</b> {{ currentData[key] ? currentData[key].lastDate : "N/A" }}</p>
                <p>
                  <b>Cycle Count:</b>
                  {{
                    currentData[key]
                      ? formatCycleCount(key, currentData[key].cycleCount)
                      : "N/A"
                  }}
                </p>
                <p><b>Status:</b> {{ cycleStatusLabel(key) }}</p>
                <div class="cpt-mobile-detail">
                  <cpt-desc
                    :cpt="key"
                    :currentInfo="currentData[key]"
                    :historicalInfo="getHistoricalData(key)"
                    :measurements="getCptMeas(key)"
                    @cycle-shown="cycleShown(key, $event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import cptInfo from "@/data/cptInfo";
import { listAllPatientDevices } from "@/api2/devices";
import { meterRowsFromDevices } from "@/utils/meterRows";
import CptDesc from "../private-layouts/CptDesc.vue";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import HelpIcon from "@/components/help/HelpIcon.vue";

export default {
  name: "CptPage",
  components: {
    "cpt-desc": CptDesc,
    HelpIcon,
  },
  data() {
    return {
      cptInfo,
      addedMeter: {
        99453: 0,
        99454: 0,
        99457: 0,
        99458: 0,
        98975: 0,
        98976: 0,
        98980: 0,
        98981: 0,
        99091: 0,
      },
      currentMeters: [],
      // Why the meters could not be listed, when they could not.
      deviceLoadError: "",
      assignedMeters: {
        99453: [],
        99454: [],
        99457: [],
        99458: [],
        98975: [],
        98976: [],
        98980: [],
        98981: [],
        99091: [],
      },
      currentData: {},
      historicalData: {},
      // The device readings that dot the calendars, one cycle's days at a time
      // (see readCycleOnScreen): the cycle's `firstDate|lastDate` to the rows
      // read for those days.
      readings: {},
      // The cycles asked for - until a read fails, so that the next opening of
      // the row asks again - and the ones whose read failed.
      readingsAsked: {},
      readingsFailed: {},
      // Per CPT code: the cycle its detail is showing, and whether its row is
      // open.
      cycleOnScreen: {},
      openCodes: {},
    };
  },
  mounted() {
    // Check db if cptCodes exists for patient, if not then make one
    this.getDevices();
    this.getAddedMeters();
    this.getCptData();
    // A row's detail is a Bootstrap collapse, which says when it has opened
    // and when it has closed. The readings are read for the cycle in a row that
    // is open, not for the chart when the page is.
    this.$el.addEventListener("shown.bs.collapse", this.collapseChanged);
    this.$el.addEventListener("hidden.bs.collapse", this.collapseChanged);
  },
  beforeUnmount() {
    this.$el.removeEventListener("shown.bs.collapse", this.collapseChanged);
    this.$el.removeEventListener("hidden.bs.collapse", this.collapseChanged);
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    // Said while a cycle on screen is without its readings, so that a calendar
    // with no dots is not read as a patient who did not measure.
    readingsLoadError() {
      const failed = Object.keys(this.openCodes).some((code) => {
        const cycle = this.cycleOnScreen[code];

        return this.openCodes[code] && cycle && this.readingsFailed[this.cycleKey(cycle)];
      });

      return failed
        ? "The readings for the cycle on screen could not be loaded, so its calendar shows no dots. Close the row and open it again to try again."
        : "";
    },
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    showCpt(key) {
      const entry = document.getElementById(`cpt${key}`);
      if (entry) {
        entry.classList.toggle("active");
        this.setOpen(key, entry.classList.contains("active"));
      }
    },
    /** Bootstrap's `shown` / `hidden` for the collapse under a row (`cptInfo<code>`). */
    collapseChanged(event) {
      const id = (event.target && event.target.id) || "";

      if (id.startsWith("cptInfo")) {
        this.setOpen(id.slice("cptInfo".length), event.type === "shown.bs.collapse");
      }
    },
    setOpen(code, open) {
      this.openCodes[code] = open;

      if (open) this.readCycleOnScreen(code);
    },
    /** CptDesc says which cycle it is showing: when it arrives, and as the person walks to others. */
    cycleShown(code, cycle) {
      this.cycleOnScreen[code] = cycle;

      if (this.openCodes[code]) this.readCycleOnScreen(code);
    },
    cycleKey(cycle) {
      return `${cycle.firstDate}|${cycle.lastDate}`;
    },
    cycleStatusLabel(key) {
      if (!this.currentData[key]) {
        return "N/A";
      }
      return { 0: "Not Billable", 1: "Billable", 2: "Billed" }[this.currentData[key].status];
    },
    fmtMSS(s) {
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    },
    formatCycleCount(cpt, count) {
      let append = " unique daily recordings";
      if (cpt === "98980" || cpt === "98981" || cpt === "99457" || cpt === "99458") {
        append = " minutes";
        return `${this.fmtMSS(count)} ${append}`;
      }
      return `${count} ${append}`;
    },
    /**
     * The readings for the cycle a CPT code's detail is showing, read when its
     * row is open and only that cycle's days.
     *
     * Main read every Fora reading of the chart in one request. The API pages
     * them at 100, so the same read here was a request per 100 readings of the
     * chart's years of them - the request-volume alert fires at 60 a minute -
     * to dot a calendar that shows one cycle. A cycle is read once, however
     * many codes show it (a patient's cycles usually open together) and however
     * often the person walks back to it; a read that fails is asked again the
     * next time the row is opened.
     */
    async readCycleOnScreen(code) {
      const cycle = this.cycleOnScreen[code];

      if (!cycle) return;

      const key = this.cycleKey(cycle);

      if (this.readingsAsked[key]) return;

      this.readingsAsked[key] = true;
      this.readingsFailed[key] = false;

      try {
        const rows = await this.getMeasurements(cycle);

        this.readings[key] = Array.isArray(rows) ? rows : [];
      } catch (error) {
        this.readingsAsked[key] = false;
        this.readingsFailed[key] = true;
        console.error("Could not load the cycle's readings:", error);
      }
    },
    async getMeasurements(cycle) {
      let content = {
        PatientCpt: {
          API_Meth: "GetMeasurements2",
          pid:
            ("" + this.allData.patient.externId).length == 7
              ? "0" + this.allData.patient.externId
              : "" + this.allData.patient.externId,
          // The cycle on screen; the bridge reads these days and no others.
          firstDate: cycle.firstDate,
          lastDate: cycle.lastDate,
        },
      };
      const res = await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      });

      return res.data.data;
    },
    getCptMeas(cpt) {
      const cycle = this.cycleOnScreen[cpt];
      const readings = cycle ? this.readings[this.cycleKey(cycle)] : null;

      if (readings && readings.length != 0) {
        let meters = this.assignedMeters[cpt].map((m) => m.meter);
        let answer = readings.filter((meas) => meters.includes(meas.MDeviceID));
        return answer;
      }
      return [];
    },
    getHistoricalData(key) {
      let data = this.historicalData[key];
      if (data) {
        let current = this.currentData[key];
        data[current.fid] = current;
      }
      return data;
    },
    async getCptData() {
      let content = {
        PatientCpt: {
          API_Meth: "GetPatientCpt2",
          pid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.currentData = res.data.current;
          this.historicalData = res.data.historical;
        });
    },
    availableMeters(key) {
      let result = [];
      let meterNames = this.assignedMeters[key].map((meter) => meter.meter);
      this.currentMeters.forEach((meter) => {
        if (!meterNames.includes(meter.MeterID._text)) {
          result.push(meter);
        }
      });
      return result;
    },
    async getAddedMeters() {
      let content = {
        PatientCpt: {
          API_Meth: "GetMeterCpt",
          pid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status == "Success" && res.data.count != 0) {
            let results = res.data.result;
            results.forEach((m) => {
              this.assignedMeters[m.cpt].push(m);
            });
          } else if (res.data.status != "Success") {
            alert(res.data.status);
          }
        });
    },
    async addingNewMeter(key) {
      let meterInfo = this.addedMeter[key];
      if (meterInfo == 0) return;
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.METER_CPT_ASSIGNMENTS_ADD,
          "You do not have permission to add meter CPT assignments."
        )
      ) {
        this.addedMeter[key] = 0;
        return;
      }
      let key2 =
        key === "98980"
          ? "98981"
          : key === "98981"
          ? "98980"
          : key === "99457"
          ? "99458"
          : key === "99458"
          ? "99457"
          : "";
      let confirmMsg = "";
      if (key2 === "")
        confirmMsg = `Would you like to assign the meter ${meterInfo.MeterID._text} (${meterInfo.MeterName._cdata}) to CPT code ${key}?`;
      else
        confirmMsg = `Would you like to assign the meter ${meterInfo.MeterID._text} (${meterInfo.MeterName._cdata}) to CPT codes ${key} and ${key2}?`;

      if (confirm(confirmMsg)) {
        let content = {
          PatientCpt: {
            API_Meth: "AddMeterCpt",
            pid: this.allData.patient.externId,
            meter: meterInfo.MeterID._text,
            cpt: key,
            meterName: meterInfo.MeterName._cdata,
          },
        };
        // `AddMeterCpt` is an ENROLMENT — "assign this meter to this CPT code" —
        // bridged to POST /patients/{patient}/cpt-meters (MX-06), which opens
        // no billing cycle and enrols a repeated click only once. A refusal
        // comes back as a non-Success status and is alerted below; anything
        // that throws is caught and named rather than surfacing as an
        // unhandled rejection while the grid reloads as though it had worked.
        try {
          const res = await axios.post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          });

          if (res.data.status != "Success") {
            alert(res.data.status);
          } else {
            if (key2 != "") {
              content["PatientCpt"]["cpt"] = key2;
              const paired = await axios.post(CURR_API + "/tswebhook.php", content, {
                headers: { "Content-Type": "application/json;" },
              });

              if (paired.data.status != "Success") {
                alert(paired.data.status);
                this.addedMeter[key] = 0;
                return;
              }
            }

            for (var el in this.assignedMeters) this.assignedMeters[el] = [];
            this.getAddedMeters();
          }
        } catch (error) {
          console.error("AddMeterCpt failed:", error);
          alert(
            `The meter ${meterInfo.MeterID._text} was NOT assigned to CPT code ${key}` +
            (key2 === "" ? "" : ` or ${key2}`) + ".\n\n" +
            "The assignment could not be saved. Nothing has been billed."
          );
        }
      }
      this.addedMeter[key] = 0;
    },
    /**
     * The chart's meters, for the Add Meter pickers.
     *
     * Main posted `GetPatientInfo.GetPatientDevice` and unpacked the Fora XML
     * blob it answered. That operation is unmapped on the port on purpose - there
     * is no Fora XML to parse - so the bridge threw, the rejection was logged and
     * dropped, and every picker was empty with nothing to say why. The meters are
     * `GET /patients/{patient}/devices` (every page: a chart can hold more than
     * one), in the shape the picker reads, from the mapper the Devices page
     * shares so that a meter is keyed the same on both. When the list cannot be
     * read, that is said above the pickers: an empty list and an unreachable one
     * look the same on screen.
     */
    async getDevices() {
      const patientId = this.allData && this.allData.patient ? this.allData.patient.externId : null;

      this.deviceLoadError = "";

      if (!patientId) {
        this.currentMeters = [];
        return;
      }

      try {
        const page = await listAllPatientDevices(patientId);

        this.currentMeters = meterRowsFromDevices(page.items);
      } catch (error) {
        this.currentMeters = [];
        this.deviceLoadError = "The list of this patient's meters could not be loaded, so none can be assigned here. Reload the page to try again.";
        console.error("Could not load devices:", error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  margin: 1.5rem auto;
  padding: 2rem;
  margin-bottom: 100px;
}

.page-help-corner {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.35rem;
}

.device-load-error {
  margin: 0 0 1rem;
  padding: 0.5rem 0.75rem;
  border-left: 3px solid #c0392b;
  color: #c0392b;
}

.page--mobile {
  margin: 0.75rem auto;
  padding: 1rem;
  margin-bottom: 80px;
}

.row {
  flex-wrap: nowrap;
}

.device__header,
.list__header {
  font-size: 2.5rem;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1em;
}

.list__header--mobile {
  font-size: 1.25rem;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.columntop {
  width: 100%;
  max-width: none;
  display: grid;
  grid-template-columns: 0.7fr 2.4fr 0.85fr 1.45fr 1fr 1fr 1.15fr 0.75fr;
  align-items: center;
}

.columnrow {
  width: 100%;
  max-width: none;
  display: grid;
  grid-template-columns: 0.7fr 2.4fr 0.85fr 1.45fr 1fr 1fr 1.15fr 0.75fr;
  align-items: start;
}

.cpt__list .gridarea {
  overflow-x: auto;
}

.cpt__list .gridarea .container {
  width: 100%;
  max-width: none;
  padding-left: 0;
  padding-right: 0;
}

.cpt__list .columntop > *,
.cpt__list .columnrow > * {
  flex: none;
  max-width: none;
  width: auto;
  min-width: 0;
  padding: 0.7rem 0.55rem;
  text-align: left;
}

.cpt__list .columnrow {
  border-bottom: 1px solid #d3d7db;
}

.cpt__list #cptDesc {
  line-height: 1.4;
  display: block;
}

.cpt-expand {
  width: 100%;
}

.cpt-expand__body {
  width: 100%;
  padding: 0.75rem 1rem;
  box-sizing: border-box;
}

.columnbottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  max-width: 1500px;
  text-align: center;
  justify-content: center;
}

.pagnav a {
  margin-left: 10px;
}

.searchfindarea .container {
  display: flex;
  flex-direction: row;
}

.gridarea {
  width: 100%;
  height: auto;
}

.top-row-device {
  border-right: 1px solid #d3d7db;
}

.top-row-device:last-child {
  border-right: none;
}

.meterList {
  display: flex;
  flex-direction: column;
}

.meterListColumn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#meterOptions {
  margin-bottom: 5%;
}

.table-container {
  padding: 0;
}

.accordion {
  margin-top: 0;
}

.accordion-item {
  border-bottom: 1px solid #d3d7db;
}

.accordion-button,
button.accordion-button {
  padding: 12px 15px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 0.95rem;
  line-height: 1.35;
  word-break: break-word;
}

.accordion-content {
  display: none;
  padding: 15px;
}

.accordion-item.active .accordion-content {
  display: block;
}

.accordion-content p {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  word-break: break-word;
}

.cpt-mobile-meters {
  margin-bottom: 0.75rem;
}

.cpt-mobile-meter-list {
  list-style: none;
  padding-left: 0;
  margin: 0 0 0.5rem;

  li {
    font-size: 0.95rem;
    padding: 0.15rem 0;
    word-break: break-word;
  }
}

.cpt-mobile-empty {
  font-size: 0.9rem;
  margin-bottom: 0.5rem !important;
}

.cpt-mobile-select {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #d3d7db;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 0.25rem;
}

.cpt-mobile-detail {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid #d3d7db;
}
</style>
